import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import cn from 'classnames';

import { rerenderOnResize } from '../../decorators';
import services, { events } from '../../services/services';
import { browserHistory } from '../../browserHistory';
import { setMobileMenuEnabled, setMobileSidebarEnabled } from '../../actions/actions';
import { getUserFullName, generateRoomURL, parseRoomURL } from '../../utils/utilsChat';
import {
  isWithinElement,
  isMobileSizeScreen,
  getFromLocalStorage,
  stringifyTimePeriod,
  exposeComponentToGlobalScope,
} from '../../utils/utilsGlobal';

import { Avatar, Switcher, Tooltip } from '../../components';

import logoImg from '../../../public/assets/images/logo.svg';
import styles from './Header.scss';
import uiStyles from '../../styles/ui.scss';


const mapStateToProps = state => {
  return {
    companies: state.companies,
    currentCompany: state.currentCompany,
    currentOperator: state.currentOperator,
    totalUnreadCount: state.totalUnreadCount,
    documentTitleBase: state.documentTitleBase,
    isMobileMenuEnabled: state.isMobileMenuEnabled,
    isMobileSidebarEnabled: state.isMobileSidebarEnabled,
    workHoursSchedulerCanSwitchOff: state.workHoursSchedulerCanSwitchOff,
  };
};

const mapDispatchToProps = {
  setMobileMenuEnabled,
  setMobileSidebarEnabled,
};

@connect(mapStateToProps, mapDispatchToProps)
@rerenderOnResize()
export class Header extends Component {

  state = {
    isUserMenuOpen: false,
    scheduleTitle: {},
    schedulerTitleText: '',
    schedulerTitleHint: null,
    schedulerTitleHighlighted: false,
    isSchedulerTitleAnimating: false,
    isSwitcherUnavailablePopupOpen: false,
  };

  DEFAULT_HEADER_TITLE = 'Эликсир';

  updateSchedulerHintInterval = null;

  componentDidMount(){
    document.body.addEventListener('click', this.onBodyClick);
    exposeComponentToGlobalScope(this);

    services.workHoursScheduler.on(events.WORK_HOURS_SCHEDULER_TITLE_UPDATE, schedulerTitle => {
      this.animateSchedulerTitleChange(schedulerTitle);
    });

    this.updateSchedulerHintInterval = setInterval(() => {
      const { scheduleTitle } = this.state;
      const schedulerTitleHint = this.generateSchedulerTitleHint(scheduleTitle);
      this.setState({ schedulerTitleHint });
    }, 30 * 1000);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.onBodyClick);
    clearInterval(this.updateSchedulerHintInterval);
  }

  onBodyClick = (e) => {
    if (!isWithinElement(e.target, styles.user)) {
      this.toggleUserMenu(false);
    }
  };

  toggleUserMenu = isUserMenuOpen => {
    this.setState({ isUserMenuOpen });
  };

  generateSchedulerTitleHint = (scheduleTitle) => {
    const { upcomingEventType, willHappenAt } = scheduleTitle.upcomingEvent || {};
    if (upcomingEventType === 'WAITING_WORKDAY_TO_START_IN_MORE_THAN_3_HOURS') {
      return `До начала рабочего дня\n ${stringifyTimePeriod(willHappenAt - Date.now(), { format: 'string' })}`
    }
    return '';
  };

  animateSchedulerTitleChange = (scheduleTitle) => {
    const schedulerTitleText = isMobileSizeScreen() ? scheduleTitle.textShort : scheduleTitle.text;
    const schedulerTitleHint = this.generateSchedulerTitleHint(scheduleTitle);
    const schedulerTitleHighlighted = scheduleTitle.isHighlighted;

    this.setState({ isSchedulerTitleAnimating: true }) ;
    setTimeout(() => {
      this.setState({
        scheduleTitle,
        schedulerTitleText,
        schedulerTitleHint,
        schedulerTitleHighlighted,
        isSchedulerTitleAnimating: false,
      });
    }, 300);
  };

  onCompanyLinkClick = (companyId) => {
    const { currentCompany } = this.props;
    const latestRoomId = getFromLocalStorage('LATEST_OPENED_ROOM_' + companyId);
    const companyPath = generateRoomURL(companyId, latestRoomId);
    if (companyId === currentCompany.id) {
      browserHistory.push(companyPath); // React router redirect to company without re-fetching company data
    }
    else {
      location.pathname = companyPath; // Hard redirect if different company with re-fetching company data
    }
  };

  onSwitcherToggle = () => {
    const {
      isSchedulerEnabled,
      onSchedulerChange,
      workHoursSchedulerCanSwitchOff,
    } = this.props;

    if (isSchedulerEnabled && !workHoursSchedulerCanSwitchOff) {
      this.setState({ isSwitcherUnavailablePopupOpen: true });
    }
    else {
      onSchedulerChange();
    }
  };

  render(){
    const {
      isUserMenuOpen,
      schedulerTitleText,
      schedulerTitleHint,
      schedulerTitleHighlighted,
      isSchedulerTitleAnimating,
      isSwitcherUnavailablePopupOpen,
    } = this.state;

    const {
      className,
      companies,
      currentCompany,
      currentOperator,
      documentTitleBase,
      totalUnreadCount,
      isAppMuted,
      isSchedulerEnabled,
      workHoursSchedulerCanSwitchOff,
      onToggleMuteClick,
      onLogoutClick,
      isMobileMenuEnabled,
      isMobileSidebarEnabled,
      setMobileMenuEnabled,
      setMobileSidebarEnabled,
    } = this.props;

    const hasMultipleCompanies = companies?.length > 1;
    const isMobileSize = isMobileSizeScreen();
    const isSchedulerVisible = !isMobileSize || (isMobileSize && isMobileMenuEnabled);
    const isAvatarMenuVisible = currentOperator?.id && (!isMobileSize || (isMobileSize && !isMobileMenuEnabled));
    const versionTitle = 'Версия ' + process.env.ELIXIRCHAT_VERSION;

    let switcherColor = null;
    if (schedulerTitleHighlighted) {
      switcherColor = '#FF0066';
    }
    if (!workHoursSchedulerCanSwitchOff) {
      switcherColor = '#F8CD46';
    }

    return (
      <div className={cn({
        [className]: true,
        [styles.container]: true,
        [styles.containerOverlap]: isUserMenuOpen || isSwitcherUnavailablePopupOpen,
      })}>

        {!isMobileSize && (
          <Fragment>
            <Link to="/">
              <img className={styles.logoImg} src={logoImg} alt="Эликсир"/>
            </Link>
            <div className={styles.title}>
              <Tooltip className={styles.titleVersionTooltip} title={versionTitle} placement="bottom">
                <Link className={styles.titleLink} to="/">
                  {currentCompany.name}
                </Link>
              </Tooltip>
              <Tooltip className={styles.muteIconTooltip}
                title={isAppMuted ?  'Включить звук уведомлений' : 'Выключить звук уведомлений'}
                placement="bottom">
                <i onClick={onToggleMuteClick} className={cn({
                  [styles.muteIcon]: true,
                  'icon-speaker': !isAppMuted,
                  'icon-speaker-mute': isAppMuted,
                })}/>
              </Tooltip>
            </div>
          </Fragment>
        )}

        {isMobileSize && (
          <div className={styles.mobileLeftBlock}>
            {(!isMobileMenuEnabled && !isMobileSidebarEnabled) && (
              <span className={styles.mobileTopLeftIcon} onClick={() => setMobileMenuEnabled(true)}>
                <i className={cn(styles.mobileMenuIcon, 'icon-menu')}/>
                {Boolean(totalUnreadCount) && (
                  <span className={styles.mobileMenuIconCounter}>{totalUnreadCount}</span>
                )}
              </span>
            )}
            {(isMobileMenuEnabled || isMobileSidebarEnabled) && (
              <span className={styles.mobileTopLeftIcon} onClick={() => {
                setMobileMenuEnabled(false);
                setMobileSidebarEnabled(false);
              }}>
                <i className={cn(styles.mobileCloseIcon, 'icon-close-medium')}/>
              </span>
            )}
            {!isMobileMenuEnabled && (
              <span className={styles.mobileRoomName} onClick={() => setMobileSidebarEnabled(true)}>
                {documentTitleBase || this.DEFAULT_HEADER_TITLE}
              </span>
            )}
          </div>
        )}

        {isSchedulerVisible && (
          <div className={styles.scheduler}>
            <Tooltip className={styles.schedulerCaptionTooltip}
              title={schedulerTitleHint}
              placement="bottom">
              <span className={cn({
                [styles.schedulerCaption]: true,
                [styles.schedulerCaptionAnimating]: isSchedulerTitleAnimating,
                [styles.schedulerCaptionHighlighted]: isSchedulerEnabled && schedulerTitleHighlighted,
              })}>
                {schedulerTitleText}
              </span>
            </Tooltip>
            <Tooltip className={styles.schedulerSwitcherTooltip}
              title={isSchedulerEnabled ? 'Уйти на перерыв' : 'Начать работу'}
              placement="bottom">
              <Switcher className={styles.schedulerSwitcher}
                onChange={this.onSwitcherToggle}
                enabled={isSwitcherUnavailablePopupOpen ? false : isSchedulerEnabled}
                theme={switcherColor}/>
            </Tooltip>

            {isSwitcherUnavailablePopupOpen && (
              <div className={styles.schedulerSwitcherUnavailable}>
                <h2 className={styles.schedulerSwitcherUnavailableHeader}>
                  Невозможно уйти на перерыв
                </h2>
                <div className={styles.schedulerSwitcherUnavailableText}>
                  Сейчас нельзя уйти на перерыв, так как останется мало менеджеров. Попробуйте позднее
                </div>
                <button
                  className={uiStyles.buttonSecondary}
                  onClick={() => this.setState({ isSwitcherUnavailablePopupOpen: false })}>
                  Закрыть
                </button>
              </div>
            )}

          </div>
        )}

        {isAvatarMenuVisible && (
          <div className={styles.user} onClick={() => this.toggleUserMenu(!isUserMenuOpen)}>
            <div className={styles.userButton} tabIndex={0}>
              <span className={styles.userName}>{getUserFullName(currentOperator)}</span>
              <Avatar className={styles.userAvatar} user={currentOperator}/>
            </div>
            {isUserMenuOpen && (
              <ul className={styles.userMenu}>
                {isMobileSize && !hasMultipleCompanies && (
                  <li className={styles.userMenuItem}>
                    <span className={styles.userMenuInner} onClick={() => this.onCompanyLinkClick(currentCompany.id)}>
                      Назад к чатам
                    </span>
                  </li>
                )}
                {hasMultipleCompanies && companies.map(company => (
                  <li key={company.id} className={cn({
                    [styles.userMenuItem]: true,
                    [styles.userMenuItemChecked]: company.id === currentCompany.id,
                  })}>
                    <span className={styles.userMenuInner} onClick={() => this.onCompanyLinkClick(company.id)}>
                      <i className={cn('icon-system-case-closed', styles.userMenuInnerCheckmark)}/>
                      {company.name}
                    </span>
                  </li>
                ))}
                {currentOperator.isManager && (
                  <Fragment>
                    <li className={cn(styles.userMenuItem, styles.userMenuItemTopDivider)}>
                      <Link className={styles.userMenuInner} to="/schedule">Расписание операторов</Link>
                    </li>                    
                  </Fragment>
                )}
                <li className={styles.userMenuItem}>
                  <Link className={styles.userMenuInner} to="/analytics">Центр аналитики</Link>
                </li>
                <li className={cn(styles.userMenuItem, styles.userMenuItemTopDivider)}>
                  <Link className={styles.userMenuInner} to="/issues">Проблемы</Link>
                </li>
                <li className={styles.userMenuItem}>
                  <Link className={styles.userMenuInner} to="/profile">Настройки профиля</Link>
                </li>
                <li className={cn(styles.userMenuItem, styles.userMenuItemTopDivider)}>
                  <span className={styles.userMenuInner} onClick={onLogoutClick}>
                    Выйти из системы
                  </span>
                </li>
              </ul>
            )}
          </div>
        )}

      </div>
    );
  }
}
